//@flow
import * as React from 'react';
import classnames from 'classnames';
import IconWithPopover from './IconWithPopover';
import { themr } from 'react-css-themr';

import theme from './ErrorIcon.scss';

type ErrorIconParams = {
    theme: Object,
    error: string,
    place: string,
    visible: boolean,
    isPopOverOpen: boolean,
    errorText: string,
    className?: string
};

const ErrorIcon = ({
    errorText,
    place,
    isPopOverOpen,
    theme,
    visible,
    className,
    ...others
}: ErrorIconParams) => {
    return visible ? (
        <IconWithPopover
            {...others}
            invert
            theme={theme}
            bgColor="salmon-two"
            place={place}
            isPopOverOpen={isPopOverOpen}
            popOverContent={errorText}
            className={classnames(theme.errorIcon, { className })}
            icon="alert"
        />
    ) : null;
};

ErrorIcon.defaultProps = {
    place: 'right',
    isPopOverOpen: false
};

const ThemedErrorIcon = themr('ErrorIcon', theme)(ErrorIcon);

export { ThemedErrorIcon };
export default ThemedErrorIcon;
